import InputLabel from '@material-ui/core/InputLabel'
import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.main`
  display: grid;
  padding: 16px;
  flex-direction: column;
  grid-template-rows: 1fr;
  grid-template-columns: repeat(2, 40%);
  grid-gap: 0 32px;
  border-radius: 8px;

  ${({ theme }) => css`
    background-color: ${theme.colors.mainBg};
  `}

  ${media.lessThan('medium')`   
    grid-template-rows: repeat(2,1fr);
    grid-template-columns: 1fr;
    grid-gap: 40px 0;
  `}
`

export const GridMuro = styled.section`
  display: grid;
  row-gap: 16px;
  grid-template-columns: 1fr;
  grid-template-rows: 32px 1fr 1fr 1fr;

  ${media.lessThan('medium')`   
    row-gap: 8px;
  `}
`
export const Campos = styled.div`
  display: grid;
  flex-direction: column;
  grid-template-columns: 160px 20%;

  ${media.lessThan('medium')`   
  grid-template-columns: 160px 1fr;
  `}
`

export const Label = styled(InputLabel)`
  font-family: 'IBMPlexSans-Bold';
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.small};
    font-weight: 600;
  `};
`
export const Valor = styled(Label)`
  text-align: end;
`

export const NomeSubSessao = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.darkGray};
    font-weight: ${theme.font.bold};
    font-size: ${theme.font.sizes.medium};
  `}
`
